<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="show_table_view"></heading-view>

        <canton-add-view v-if="show_add_view"></canton-add-view>
        <canton-table-view v-if="show_table_view"></canton-table-view>

    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    import CantonTableView from './CantonTableView'
    import HeadingView from '../heading/HeadingView'
    import CantonAddView from './CantonAddView'

    export default {

        components: {
            CantonTableView,
            HeadingView,
            CantonAddView
        },

        created: function () {
            let table = 'zupanija';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'CantonAddView';
            this.show_table_view = this.$route.matched[0].name === 'CantonTableView';

            serverBus.$on('show-canton-add-form', (item) => {
                this.$navigate('/admin/zupanija/add' + (item.id > 0 ? '/' + item.id : ''));
            });
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-canton-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-canton-add-form');
            serverBus.$off('show-canton-profile');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false
            };
        }
    }
</script>